import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TopPage from './TopPage.jsx';
import ContactPage from './ContactPage.jsx';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TopPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

export default AppRoutes;
